/**
 * Centralized limits and thresholds configuration
 * Single source of truth for all numeric limits and boundaries
 * 
 * @module config/limits
 */

/**
 * Application limits and boundaries
 */
export const LIMITS = {
  /** Maximum number of images to upload per lot */
  MAX_UPLOAD_IMAGES: 20,
  
  /** Maximum number of pages to return */
  MAX_PAGES: 5,
  
  /** Default page size for pagination */
  PAGE_SIZE: 100,
  
  /** Maximum lots to refresh per tick interval */
  BID_REFRESH_BATCH_LIMIT: 10,
  
  /** Maximum logos to refresh per tick interval */
  LOGO_REFRESH_BATCH_LIMIT: 5,
  
  /** Number of table columns in portal */
  TABLE_COLUMN_COUNT: 12,
} as const;

/**
 * Estimate cache configuration
 */
export const ESTIMATE_CONFIG = {
  /** Time-to-live for cached estimates: 24 hours */
  TTL_HOURS: 24,
  
  /** Cache key for storing last estimate */
  CACHE_KEY: 'lotlingo_last_estimate',
} as const;

/**
 * Storage keys for persisted data
 */
export const STORAGE_KEYS = {
  /** Key for storing last estimate */
  ESTIMATE_CACHE: 'lotlingo_last_estimate',
  
  /** Key for storing pending price review state */
  PENDING_PRICE_REVIEW: 'lotlingo_pending_price_review',
} as const;
